<template src="../../../../agilis/mobile/TrackerDataTableViewMobile/TrackerDataTableViewMobile.html" />

<script>
import PropositionTableView from '@/applications/sales/components/PropositionTable/PropositionTableView'
import TrackerDataTableViewMobile from '@/agilis/mobile/TrackerDataTableViewMobile/TrackerDataTableViewMobile'
import { computed } from 'vue'
export default {
  name: 'PropositionTableViewMobile',
  mixins: [PropositionTableView, TrackerDataTableViewMobile],
  provide () {
    return {
      provideJlAssertionContext: computed(() => {
        return this.jlAssertionContext
      })
    }
  },
  mounted () {
    this.fetchWorkPackageData()
    this.fetchParentData(this.trackerId)
  },
  methods: {
    agilisUrlWorkPackage3 (applicationId, trackerTypeId, trackerId) {
      return `/api/${applicationId}/tracker/${trackerTypeId}/${trackerId}/workpackage3`
    },
    agilisUrlWorkPackage (applicationId, trackerTypeId, trackerId) {
      return `/api/${applicationId}/tracker/${trackerTypeId}/${trackerId}/workpackage`
    },
    async fetchWorkPackageData () {
      const [responseWP3, responseWP] = await Promise.all([
        this.$axios.get(this.agilisUrlWorkPackage3(this.applicationId, this.trackerTypeId, this.trackerId), this.$axios.agilisRequestConfig(this.agilisUrlWorkPackage3(this.applicationId, this.trackerTypeId, this.trackerId))),
        this.$axios.get(this.agilisUrlWorkPackage(this.applicationId, this.trackerTypeId, this.trackerId), this.$axios.agilisRequestConfig(this.agilisUrlWorkPackage(this.applicationId, this.trackerTypeId, this.trackerId)))
      ])
      this.workpackages = [...responseWP3.data, ...responseWP.data]
    }
  }
}
</script>
